import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
  AlertIcon,
  AlertDescription,
} from '@chakra-ui/react'
import { useFeatureToggle } from '../../common/utils/feature-toggle/useFeatureToggle'
import { useSSOContext, SSO_PROVIDER_TYPE } from '../../features/sso'
import SSOOIDCAuthenticationModal from './SSOOIDCAuthenticationModal'
import SSOSamlAuthenticationModal from './SSOSamlAuthenticationModal'

export interface SSOAuthenticationModalProps {
  isOpen: boolean
  onClose: () => void
  onSuccess: () => void
  onError?: (error: string) => void
}

const SSOAuthenticationModal = ({
  isOpen,
  onClose,
  onSuccess,
  onError,
}: SSOAuthenticationModalProps) => {
  const { context: clientSSOContextData } = useSSOContext()

  const { isFeatureEnabled: isSSOSAMLReauthenticationFeatureOn } = useFeatureToggle(
    'SSO_SAML_REAUTHENTICATION'
  )

  if (!clientSSOContextData) {
    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>SSO Authentication</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Alert status="error">
              <AlertIcon />
              <AlertDescription>
                No SSO client context found. Please refresh the page and try again.
              </AlertDescription>
            </Alert>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  if (
    clientSSOContextData.providerType === SSO_PROVIDER_TYPE.SAML &&
    isSSOSAMLReauthenticationFeatureOn
  ) {
    return <SSOSamlAuthenticationModal isOpen={isOpen} onClose={onClose} onSuccess={onSuccess} />
  }

  return (
    <SSOOIDCAuthenticationModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      onError={onError}
    />
  )
}

export default SSOAuthenticationModal
